import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { OptionsDialog } from '../OptionsDialog';
import * as S from './styles';

const msgs = defineMessages({
  title: {
    id: 'blob_session_skip_modal_title',
    defaultMessage: 'Choose what we should do with “{phrase}”.',
  },
  skip: { id: 'learning_skipButton_CTA' },
  skipDescription: {
    id: 'blob_session_skip_modal_skip_description',
    defaultMessage: 'We’ll show it to you again later',
  },
  alreadyKnow: { id: 'scenario_lesson_i_already_know_this' },
  alreadyKnowDescription: {
    id: 'blob_session_skip_modal_already_know_description',
    defaultMessage: 'We won’t ask you about it again',
  },
});

type SkipModalProps = {
  isOpen: boolean;
  phrase: string;
  onSkip: () => void;
  onAlreadyKnow: () => void;
  onClose: () => void;
};

export const SkipModal: FC<SkipModalProps> = ({
  isOpen,
  phrase,
  onSkip,
  onAlreadyKnow,
  onClose,
}) => {
  const intl = useIntl();

  return (
    <OptionsDialog
      isOpen={isOpen}
      onClose={onClose}
      contentLabel={intl.formatMessage(msgs.title, { phrase })}
      data-testid="blob-skip-modal"
    >
      <S.Title>{intl.formatMessage(msgs.title, { phrase })}</S.Title>
      <S.OptionsList>
        <S.OptionButton type="button" onClick={onSkip} data-testid="blob-skip-option">
          <S.OptionIcon name="next" />
          <S.OptionText>
            <S.OptionTitle>{intl.formatMessage(msgs.skip)}</S.OptionTitle>
            <S.OptionDescription>{intl.formatMessage(msgs.skipDescription)}</S.OptionDescription>
          </S.OptionText>
        </S.OptionButton>
        <S.OptionButton
          type="button"
          onClick={onAlreadyKnow}
          data-testid="blob-already-know-option"
        >
          <S.OptionIcon name="tickOutline" />
          <S.OptionText>
            <S.OptionTitle>{intl.formatMessage(msgs.alreadyKnow)}</S.OptionTitle>
            <S.OptionDescription>
              {intl.formatMessage(msgs.alreadyKnowDescription)}
            </S.OptionDescription>
          </S.OptionText>
        </S.OptionButton>
      </S.OptionsList>
    </OptionsDialog>
  );
};
